import { render, staticRenderFns } from "./NewTabs2.vue?vue&type=template&id=d4f0e316&scoped=true"
import script from "./NewTabs2.vue?vue&type=script&lang=js"
export * from "./NewTabs2.vue?vue&type=script&lang=js"
import style0 from "./NewTabs2.vue?vue&type=style&index=0&id=d4f0e316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f0e316",
  null
  
)

export default component.exports